<template>
	<a-carousel :dot-position="bottom">
		<div>
			<img class="bannerImg" src="@/assets/img/jf/banner.jpg" />
			<div class="btnTop">
				<img class="bannerImg" src="@/assets/img/jf/banner.png" />
				<div @click="integralPost" class="btnCon"><img src="@/assets/img/download.png" alt="">查看我的积分</div>
			</div>
		</div>
	</a-carousel>
	<div style="overflow: hidden;min-width:1200px;margin:0 auto" v-if="current.indexOf('首页') > -1">


		<div class="itemTitle"><span v-if="this.dataD[0]" >{{this.dataD[0].year}}年</span>高新区企业创新积分榜</div>
		<!-- <FLAWER></FLAWER> -->
		<!-- <SWIPE></SWIPE> -->
		<BANG></BANG>
		<div class="itemTitle">参评企业总览</div>
		<WIND></WIND>
		<div class="itemTitle">创新积分应用</div>
		<Pku></Pku>
	</div>
</template>

<script>
import { message } from 'ant-design-vue';
import { ls } from "@/utils/util"
import {companyPointsSystem} from "@/api/integral";
import { dictMixin } from "@/mixins";
import BANG from "./cont/bang";
// import SWIPE from "./cont/swipe";
// import FLAWER from "./cont/flawer";
import WIND from "./cont/wind";
import Pku from "./cont/pku";
import { file_service } from "@/api/adminService";
import { getBannerInfo } from "@/api/homeService";
export default {
	name: "index",
	components: {
		// DictRender
		// FLAWER,
		// SWIPE,
		BANG,
		WIND,
		Pku
	},
	mixins: [dictMixin],
	data() {
		return {
			dataA:[],
			dataB:[],
			dataC:[],
			dataD:[],
			dictNames: 'paymentType,guarantee,investmentField,position',
			InvestorData: [],
			MechanisData: [],
			productData: [],
			current: ['首页'],
			clickMenuTitle: '',
			formState: {
				user: null,
			},
			formSearchBox: {
				city: null,
				company: null,
				project: null,
				demand: null
			},
			bannerData: [],
		}
	},
	mounted() {
		this.getBannerList()
	},
	methods: {
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},

		integralPost() {
				if (ls.get("token") && ls.get("refresh_token")) {
					// this.goMore('/sys/manage', 'user')
                    if (ls.get('roleCode').includes('company')) {
                        this.goMore('/sys/manage')
                    }else{
                        this.$notification.warning({
                            message: '提示',
                            description: '请使用企业账号登录',
                        })
                    }
				} else {
					message.success('请登录后操作')
					this.goMore('/login', 'user',true)
				}
		},
		goMore(url, key, jf) {
			this.$router.push({
				path: url,
				query: { id: key, jf: jf }
			})
		},
		menuClick(e) {
			this.clickMenuTitle = e.item.title
		},
		backhome() {
			this.$router.push('/')
		},
		getBannerList() {
			this.getAction({
				url: getBannerInfo.pageList,
				params: { type: 'finance' }
			}).then(res => {
				this.bannerData = res.records.reverse()
			})

			this.getAction({
				url: companyPointsSystem.getWebType,
			}).then(res => {
				this.dataA = res.A
				this.dataB = res.B
				this.dataC = res.C
				this.dataD = res.D
			})
		},
	}
}
</script>

<style scoped lang="less">
@import "../css/main.less";
@import "../css/components.less";
.btnTop{
	min-width: 1200px;
	max-width: 1400px;
	margin:0 auto;
	position: relative;
	font-size: 20px;
	.bannerImg{
		position: absolute;
		top:-200px;
		left:10px;
	}
	.btnCon{
	img{
    margin-top: 8px;
		display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 10px;
	}
		position: absolute;
			width:210px;
			display: flex;
			justify-content: center;
			bottom: 34px;
			padding: 0 20px;
			cursor: pointer;
			height: 44px;transition: width .4s,box-shadow .4s,-webkit-box-shadow .4s;
			line-height: 40px;
			color: #fff;
			border-radius: 22px;
			border: 1px solid #fff;
			&:hover {
				width: 230px;
				box-shadow: 0 0 10px #fff;
		}
	}
}
.menuContentBox{
	position: relative;
	height:560px;
	.btnStart{
		position: absolute;
		top:0;
		left:0;
		z-index: 99;
		margin-left:830px;
		margin-top:30px;
		width:375px;
		height:500px;
	}
}
.correntItem{
	position: absolute;
	top:0;
	left:0;
	box-shadow: 1px 1px 5px 1px #defaff;
	width:450px;
	height:560px;
	&:nth-child(1){
		background: #defaff;
		z-index: 1;
		height:500px;
		margin-top: 30px;
		margin-left:0px;
		opacity: 1;
	}
	&:nth-child(2){
		background: #ffe3e3;
		z-index: 9;
		margin-left:375px;
		margin-top: 0px;
		height:560px;
	}
	&:nth-child(3){
		background: #ecffe4;
		z-index: 1;
		margin-left:750px;
		height:500px;
		margin-top: 30px;
	}
	&:nth-child(4){
		background: #d5ceff;
		z-index: 1;
		margin-left:750px;
		height:500px;
		margin-top: 30px;
		opacity: 0;
	}
}
.itemTitle{
	text-align: center;
	font-size: 35px;
	margin:20px 0;
	font-weight: 600;
	&:before {
		content: "";
		display: inline-block;
    width: 134px;
    height: 7px;
		background: url(../../../assets/img/jf/left.png) no-repeat;
	}
	&:after {
		content: "";
		display: inline-block;
    width: 134px;
		margin-left: 20px;
    height: 7px;
		background: url(../../../assets/img/jf/right.png) no-repeat;

	}
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
	border-bottom: 3px solid #1890ff
}

:deep(.ant-menu-item-selected) {
	font-weight: 600;
}

:deep(.ant-btn) {
	border-radius: 0;
}
</style>
